module.exports = __webpack_public_path__ + "img/ox.e1e8c840.svg";